var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachFileAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.56215 8.12875V3.77391H11.3041V8.12875H9.56215ZM5.20731 14.1384C4.69925 13.9933 4.28191 13.7102 3.9553 13.2892C3.62869 12.8683 3.46538 12.382 3.46538 11.8304V3.77391H5.20731V14.1384ZM5.86054 17.7094C4.35086 17.7094 3.06619 17.1796 2.00651 16.1199C0.946831 15.0602 0.416992 13.7755 0.416992 12.2658V4.20939C0.416992 3.12068 0.798041 2.19528 1.56014 1.43318C2.32223 0.671087 3.24764 0.290039 4.33635 0.290039C5.42506 0.290039 6.35046 0.671087 7.11256 1.43318C7.87465 2.19528 8.2557 3.12068 8.2557 4.20939V10.7417H6.51377V4.20939C6.49925 3.59972 6.28514 3.08439 5.87143 2.66343C5.45772 2.24246 4.94602 2.03197 4.33635 2.03197C3.72667 2.03197 3.21135 2.24246 2.79038 2.66343C2.36941 3.08439 2.15893 3.59972 2.15893 4.20939V12.2658C2.14441 13.2965 2.50006 14.1711 3.22586 14.8896C3.95167 15.6082 4.8299 15.9675 5.86054 15.9675C6.22344 15.9675 6.5682 15.9203 6.89481 15.8259C7.22143 15.7316 7.5299 15.59 7.82022 15.4013V17.3392C7.51538 17.4554 7.19965 17.5461 6.87304 17.6114C6.54643 17.6767 6.20893 17.7094 5.86054 17.7094ZM9.56215 16.8384V14.2255H6.94925V12.4836H9.56215V9.87068H11.3041V12.4836H13.917V14.2255H11.3041V16.8384H9.56215Z",
    fill: "#1D1D39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachFileAdd);
export default __webpack_public_path__ + "static/media/attach_file_add.3ff15cec5286174ab83747cdf2c7f052.svg";
export { ForwardRef as ReactComponent };